import axios from 'axios'

export default class GlobalSearchService {
  static search = q => axios.get(`global-search?q=${ q }`, { excludeLoader: true })
}
